module.exports = __webpack_public_path__ + "static/media/selected.742a61e2.svg";